import { Link } from "react-router-dom";
import team1 from "../../../assets/images/all-img/v4/team1.png";
import team2 from "../../../assets/images/all-img/v4/team2.png";
import team3 from "../../../assets/images/all-img/v4/team3.png";
import team4 from "../../../assets/images/all-img/v4/team4.png";
import facebook from "../../../assets/images/social2/facebook.svg";
import github from "../../../assets/images/social2/github.svg";
import instagram from "../../../assets/images/social2/instagram.svg";
import twitter from "../../../assets/images/social2/twitter.svg";
 
export default function TeamHomeFour() {
	return (
		<div className="fugu--team-section version-04 fugu--team-two">
			<div className="container">
				<div className="fugu--section-title">
					<div className="fugu--default-content content-black">
						<h2>Meet our creative team</h2>
						<p>
							A creative workplace gives employees the ability to come up with unique solutions to
							challenges instead of simply told what to do.
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-3 col-md-6">
						<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="0s">
							<div className="fugu--team-thumb">
								<img src={team1} alt="" />
							</div>
							<div className="fugu--team-data">
								<h4>Eleanor Pena</h4>
								<p>CEO & 3D Designer</p>
								<div className="fugu--social-icon fugu--social-icon2">
									<ul>
										<li>
											<Link to={"#"}>
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="0.10s">
							<div className="fugu--team-thumb">
								<img src={team2} alt="" />
							</div>
							<div className="fugu--team-data">
								<h4>Arlene McCoy</h4>
								<p>Marketing Officer</p>
								<div className="fugu--social-icon fugu--social-icon2">
								<ul>
										<li>
											<Link to={"#"}>
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="0.20s">
							<div className="fugu--team-thumb">
								<img src={team3} alt="" />
							</div>
							<div className="fugu--team-data">
								<h4>Kathryn Murphy</h4>
								<p>Operating Officer</p>
								<div className="fugu--social-icon fugu--social-icon2">
								<ul>
										<li>
											<Link to={"#"}>
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="0.30s">
							<div className="fugu--team-thumb">
								<img src={team4} alt="" />
							</div>
							<div className="fugu--team-data">
								<h4>Jerome Bell</h4>
								<p>Art Director</p>
								<div className="fugu--social-icon fugu--social-icon2">
								<ul>
										<li>
											<Link to={"#"}>
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
